<div class="closed-enrollment-header">
  <div class="logo-container">
    <img src="../assets/images/logo.png" alt="NCSEAA K12 Scholarships" class="logo" />
  </div>
</div>

<div class="closed-enrollment-page">
  <div class="closed-enrollment-container">
    <div class="closed-enrollment-content">
      <h1 class="title">{{ closedEnrollmentTitle }}</h1>
      <p class="message" [innerHTML]="closedEnrollmentMessage"></p>
    </div>
  </div>
</div>
